import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountTypeOverview } from '../../models/subscriptions/subscription.models';
import { PLAN_COPY, PlanKind } from './subscription-plan.data';

@Component({
    selector: 'subscription-plan-card',
    template: require('./subscription-plan-card.component.html'),
    styles: [require('./subscription-plan-card.component.css')]
})
export class SubscriptionPlanCardComponent {
    @Input() planKind: PlanKind;
    @Input() accountType: AccountTypeOverview;
    @Input() selected = false;
    @Input() savingsAmount: number;
    @Input() summaryOnly = false;

    @Output() subscribeNow = new EventEmitter<void>();

    readonly copy = PLAN_COPY;

    get plan() {
        return this.copy[this.planKind];
    }

    get isCombined() {
        return this.planKind === 'combined';
    }

    get formattedSavings(): string {
        if (!this.savingsAmount || this.savingsAmount <= 0) {
            return '';
        }
        return this.savingsAmount.toFixed(2);
    }

    get subscriptionTerm(): string {
        if (!this.accountType) {
            return '1-year subscription';
        }
        const days = this.accountType.durationDays;
        if (days >= 365 && days <= 366) {
            return '1-year subscription';
        }
        if (this.accountType.durationDays === 0) {
            return '';
        }
        return '1-year subscription';
    }

    onSubscribeNow() {
        this.subscribeNow.emit();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/subscription-plan-card.component.ts